<template>
  <div class="dcontent">
    <mt-header title="文件详情">
      <mt-button icon="back" slot="left" @click="goback">返回</mt-button>
    </mt-header>
    <div class="detail-top">
      <div class="flexleft">
        <div class="contractName">
          {{contractModal.contractName}}
        </div>
        <div class="releaseDate">
          {{contractModal.releaseDate | formatDate}}
        </div>
      </div>
      <div class="flexright">
        <span class="status">
          {{contractModal.statuss | formatStatus}}
        </span>
      </div>
    </div>
    <div class="detail-content" v-for="(item,index) in dataList">
        <div class="flex1">
          <img class="detailimg" src="/static/img/contract/fqf.png">
        </div>
        <div class="dl1 flex2">
          <span class="realname">{{item.contractSignPepoleName}}</span>
          <span class="mobile">{{item.contractSignPepoleMobile}}</span>
        </div>
        <div class="dl2 flex3">
          <span class="contentstatus">{{item.signStatus,item.otherstatus,contractModal.statuss | formatSignStatus}}</span>
          <span class="contentDate">{{item.signTime,item.otherstatus,contractModal.statuss,contractModal.lastSaveDate | formatDate}}</span>
        </div>
    </div>
  </div>
</template>

<script>
import cheader from '@/components/header';
export default {
  data () {
    return {
      dataList:'',
      contractModal:''
    }
  },
  mounted(){
    this.detailcont();
  },
  methods: {
    detailcont: function(){
      var that = this;      
      that.$http.post(
          domain("_detailcont"),
          {
            'contractId':this.$route.query.cid
          }
      )
      .then(function(response){
          that.contractModal = response.data.data.contract; 
          that.dataList=response.data.data.rows;
          },function(error){
            console.log(error);
      })
    },
    goback: function () {
      history.go(-1); //后退1页
    }
  },
  filters: {
      formatDate(times,otherstatus,statuss,lastSaveDate) {
          if(otherstatus == 1 && statuss==4){
            var otherDate = new Date(lastSaveDate);
            return otherDate.format('yyyy-MM-dd hh:mm:ss');
          }
          if(otherstatus == 2 && statuss==7){
            var otherDate = new Date(lastSaveDate);
            return otherDate.format('yyyy-MM-dd hh:mm:ss');
          }
          if(times == null || times == ""){
            return "";
          }
          var mydate = new Date(times);
          return mydate.format('yyyy-MM-dd hh:mm:ss');
      },
      formatSignStatus(value,otherstatus,statuss){
        console.log(otherstatus);
        if(value=="1"){
          if(statuss == 5){
            return "已过期";
          }
          if(otherstatus == 2 && statuss==7){
            return "已拒签";
          }
          return "待签署";
        }else{
          if(otherstatus == 1 && statuss==4){
            return "已取消";
          }
          return "已签署";
        }
      },
      formatStatus(value){
        switch (value) {
          case "1":
              return "待我签";
              break;
          case "2":
              return "待他人签";
              break;
          case "3":
              return "已完成";
              break;
          case "4":
              return "已取消";
              break;
          case "5":
              return "已过期";
              break;
          case "6":
              return "草稿箱";
              break;
          case "7":
              return "已拒签";
              break;
          default:
              return "error";
              break;
        }
      }
  },
  components:{
     cheader
  }
}
</script>
<style>
.detail-top{
  padding: 10px;
  border-bottom:10px solid #f0f0f0;
  border-top:10px solid #f0f0f0;
}
.contractName{
  display: inline-block;
  font-size: 1rem;
  color: #7d7d7d;
  margin-top:10px; 
  word-break:break-all;
}
.dcontent .status{
  display: inline-block;
  background-color: #10a0e9;
  color: #ffffff;
  -ms-border-radius: 4px;
  -moz-border-radius: 4px;
  -o-border-radius: 4px;
  -webkit-border-radius: 4px;
  float: right;
  font-size: 0.8rem;
  padding: 2px 6px;
  margin-top: 11px;
}
.detail-content{
  margin: 25px 10px 25px 0;
}
.detailimg{
  width:35px;
}
.dcontent .releaseDate{
  font-size: 0.9rem;
  color:#c1c1c1;
  margin-top: 10px;
}
.dcontent .realname{
  font-size: 0.8rem;
  color: #7d7d7d;
  margin-top: 2px;
  word-break:break-all;
}
.contentstatus{
  font-size: 0.8rem;
  color: #7d7d7d;
}
.dcontent .contentDate{
  font-size: 0.8rem;
  color:#c1c1c1;
}
.dcontent .mobile{
  font-size: 0.9rem;
  color:#c1c1c1;
  margin-top: 5px;
}
.dl1 span,.dl2 span{
  display: block;
}
.dl1,.dl2{
  margin-top: -2px;
}
.detail-content,.detail-top{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dcontent .flex1{
  -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
}
.dcontent .flex2{
  -webkit-box-flex: 2;
  -ms-flex:2;
  flex: 2;
}
.dcontent .flex3{
  -webkit-box-flex: 2;
  -ms-flex:2;
  flex: 2;
  text-align: right;
}
.flexleft{
  -webkit-box-flex: 3.5;
  -ms-flex: 3.5;
  flex: 3.5;
}
.flexright{
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/module/contract/DContent.vue